import { c as _c } from "react/compiler-runtime";
import { Tooltip } from 'platform/components';
import { CellRendererProps } from '../../types/CellRendererProps';
import { TooltipGetter } from '../../types/TooltipGetter';
import { getCellClassName } from '../../utils/getCellClassName';
import { getTooltipProps } from '../../utils/getTooltipProps';
type PlainCellRendererProps = CellRendererProps<string | null> & {
  getTooltipProps?: TooltipGetter;
};
export function PlainCellRenderer(props) {
  const $ = _c(11);
  let t0;
  if ($[0] !== props.column) {
    t0 = getCellClassName(props.column);
    $[0] = props.column;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const className = t0;
  let t1;
  if ($[2] !== props.getTooltipProps || $[3] !== props.row) {
    t1 = getTooltipProps(props.row, {}, props.getTooltipProps);
    $[2] = props.getTooltipProps;
    $[3] = props.row;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tooltipProps = t1;
  let t2;
  if ($[5] !== className || $[6] !== props.value) {
    t2 = <div className={className}>{props.value}</div>;
    $[5] = className;
    $[6] = props.value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== tooltipProps) {
    t3 = <Tooltip {...tooltipProps}>{t2}</Tooltip>;
    $[8] = t2;
    $[9] = tooltipProps;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}